import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartApiMetadataEntityParams {
  type: string;
  id?: number;
  cart_products?: object[];
  order_ids?: number[];
  isAddOnOrder?: boolean | null;
  meetsOrderMinimum?: boolean | null;
}
export class CartApiMetadataEntity extends BaseEntityClass {
  id?: number;
  cart_products?: object[];
  order_ids?: number[];
  isAddOnOrder?: boolean | null;
  meetsOrderMinimum?: boolean | null;
  constructor(params: CartApiMetadataEntityParams) {
    super();
    this.type = params.type;
    this.entity_version = 4;
    this.id = params.id;
    this.cart_products = params.cart_products;
    this.order_ids = params.order_ids;
    this.isAddOnOrder = params.isAddOnOrder;
    this.meetsOrderMinimum = params.meetsOrderMinimum;
  }
}
